import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { provide } from 'vue';
import { cloneDeep } from 'lodash';
import useVuelidate, { ValidationArgs } from '@vuelidate/core';

import NkStack from '@/core/components/layout/Stack/NkStack.vue';
import { formInjectionKey, formProps as propsDefinition } from './form.shared';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkForm',
  props: propsDefinition,
  emits: ['submit'],
  setup(__props, { expose, emit }) {

const props = __props



const validator = useVuelidate(props.rules as ValidationArgs, props.fields || {});
const originalFields = cloneDeep(props.fields);
const reset = () => {
  validator.value.$reset();
  Object.entries(originalFields || {}).forEach(([key, value]) => {
    (props.fields as Record<string, unknown>)[key] = value;
  });
};

provide(formInjectionKey, {
  validator,
  rules: props.rules,
  fields: props.fields,
});

expose({
  validator,
  reset,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    invalidate: "",
    onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('submit')), ["prevent"]))
  }, [
    _createVNode(NkStack, { spacing: 5 }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "header"),
        _createVNode(NkStack, null, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }),
        _renderSlot(_ctx.$slots, "footer")
      ]),
      _: 3
    })
  ], 32))
}
}

})